export const SUB_STATUS = [
  {
    id: "ALL",
    label: "Alla",
    color: "",
    value: -1,
  },
  {
    id: "OK",
    label: "Ok",
    color: "success",
    value: 0,
  },
  {
    id: "PRE_REMINDER",
    label: "Förfallen",
    color: "warning",
    value: 5,
  },
  {
    id: "REMINDER_1",
    label: "Påminnelse 1",
    color: "warning",
    value: 1,
  },
  {
    id: "REMINDER_2",
    label: "Påminnelse 2",
    color: "warning",
    value: 2,
  },
  {
    id: "PRE_COLLECTION",
    label: "Ska skickas",
    color: "warning2",
    value: 3,
  },
  {
    id: "IN_COLLECTION",
    label: "Skickad",
    color: "warning3",
    value: 4,
  },
];
